module.exports = __webpack_public_path__ + "static/media/284098579.ee8fd6d2.png";